export const questionnaire = {
  "questionnaire_title": "الاستبيانات",
  "questionnaire_point": "نقاط",
  "questionnaire_resume": "متابعة",
  "questionnaire_card_progress": "{{answered}} من {{total}}",
  "questionnaire_selected_count_zero": "تم اختيار {{count}}",
  "questionnaire_selected_count_one": "تم اختيار {{count}}",
  "questionnaire_selected_count_two": "تم اختيار {{count}}",
  "questionnaire_selected_count_few": "تم اختيار {{count}}",
  "questionnaire_selected_count_many": "تم اختيار {{count}}",
  "questionnaire_selected_count_other": "تم اختيار {{count}}",
  "questionnaire_about": "استبيان عن {{name}}",
  "questionnaire_questionnaire": "الأسئلة",
  "questionnaire_minutes": "دقائق",
  "questionnaire_continue": "استمر",
  "questionnaire_start": "ابدأ",
  "questionnaire_finish": "إنهاء",
  "questionnaire_completed": "اكتمل الاستبيان، شكرًا لك!",
  "questionnaire_identity_conflict": "هذه القيمة مستخدمة بالفعل من قبل مشارك آخر. لم يتم حفظ إجابتك.",
  "questionnaire_identity_unknown_external_id": "رقم الملف غير معروف — تحقق من الرقم الذي سلمه لك الفريق. لم يتم حفظ إجابتك."
}
